var _class, _temp;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

import { TEXTO_VACIO, TIPO_TEXTO } from './constantes';

var uuidv4 = function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
};

var Texto = (_temp = _class = function Texto(_ref) {
  var _ref$id = _ref.id,
      id = _ref$id === undefined ? null : _ref$id,
      _ref$tipo = _ref.tipo,
      tipo = _ref$tipo === undefined ? TIPO_TEXTO : _ref$tipo,
      _ref$x = _ref.x,
      x = _ref$x === undefined ? 0 : _ref$x,
      _ref$y = _ref.y,
      y = _ref$y === undefined ? 0 : _ref$y,
      _ref$textoHtml = _ref.textoHtml,
      textoHtml = _ref$textoHtml === undefined ? '' : _ref$textoHtml,
      libroId = _ref.libroId,
      numPagina = _ref.numPagina,
      _ref$numZona = _ref.numZona,
      numZona = _ref$numZona === undefined ? null : _ref$numZona,
      _ref$url = _ref.url,
      url = _ref$url === undefined ? 'http://' : _ref$url;

  _classCallCheck(this, Texto);

  this.id = id || uuidv4();
  this.x = x;
  this.y = y;
  this.textoHtml = textoHtml;
  this.libroId = libroId;
  this.numPagina = numPagina;
  this.numZona = numZona;
  this.tipo = tipo;
  this.url = url;
}, _class.esVacio = function (_ref2) {
  var textoHtml = _ref2.textoHtml;
  var vacio = textoHtml === TEXTO_VACIO || textoHtml === '';
  return vacio;
}, _class.vaciar = function (texto) {
  texto.textoHtml = TEXTO_VACIO;
}, _temp);
export default Texto;